import { lengthDataToString } from "./length";
function marginPropertyDataToStyle(data, defaultValue = {}) {
  const marginTop = data.marginTop ?? defaultValue.marginTop;
  const marginRight = data.marginRight ?? defaultValue.marginRight;
  const marginBottom = data.marginBottom ?? defaultValue.marginBottom;
  const marginLeft = data.marginLeft ?? defaultValue.marginLeft;
  const style = {};
  if (marginTop != null)
    style.marginTop = lengthDataToString(marginTop);
  if (marginRight != null)
    style.marginRight = lengthDataToString(marginRight);
  if (marginBottom != null)
    style.marginBottom = lengthDataToString(marginBottom);
  if (marginLeft != null)
    style.marginLeft = lengthDataToString(marginLeft);
  return style;
}
export {
  marginPropertyDataToStyle
};
//# sourceMappingURL=margin.js.map